import { render, staticRenderFns } from "./ORCList.vue?vue&type=template&id=6ac7e8ae&scoped=true"
import script from "./ORCList.vue?vue&type=script&lang=js"
export * from "./ORCList.vue?vue&type=script&lang=js"
import style0 from "./ORCList.vue?vue&type=style&index=0&id=6ac7e8ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac7e8ae",
  null
  
)

export default component.exports